import { useCallback, useEffect, useState } from 'react';
import { get } from '../api/client';
import { useEvents } from '../context/EventContext';
import { Loader } from './UI';
import AttendeeDeclaration from '../pages/attendee/Declaration';

/**
 * Stands in front of the attendee portal: when the event asks for health and
 * emergency details and makes them compulsory, nothing else opens until they
 * are given.
 */
export default function DeclarationGate({ children }) {
  const { eventId } = useEvents();
  const [state, setState] = useState({ loading: true, pending: false });

  const check = useCallback(() => {
    let alive = true;
    get('/declarations/me', eventId ? { event: eventId } : {})
      .then((d) => alive && setState({ loading: false, pending: Boolean(d?.pending) }))
      .catch(() => alive && setState({ loading: false, pending: false }));   // never lock someone out on a failed check
    return () => { alive = false; };
  }, [eventId]);

  useEffect(check, [check]);

  if (state.loading) return <Loader full label="Loading your event" />;
  if (state.pending) return <AttendeeDeclaration onDone={() => setState({ loading: false, pending: false })} />;
  return children;
}
